import { Box, Tooltip } from "@mui/material";
import { useLayoutEffect, useRef, useState } from "react";
import CommonTextField from "../commonTextField/CommonTextField";

type Props = {
  value?: string;
};

export const EllipsisTextField = ({ value = "" }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    const el = inputRef.current;
    if (!el) return;

    const updateOverflow = () =>
      setIsOverflowing(el.scrollWidth > el.clientWidth + 1);

    updateOverflow();
    const observer = new ResizeObserver(updateOverflow);
    observer.observe(el);
    return () => observer.disconnect();
  }, [value]);

  return (
    <Tooltip title={isOverflowing ? value : ""} placement="top">
      {/* Wrapper is needed because disabled inputs don't reliably emit hover events */}
      <Box sx={{ width: "100%" }}>
        <CommonTextField
          ref={inputRef}
          fullWidth
          disabled
          value={value}
          inputProps={{ style: { textOverflow: "ellipsis" } }}
        />
      </Box>
    </Tooltip>
  );
};
